import React from "react";
import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";

function LicenseCard({ image, name, discription, status, onCardClick }) {
  const handleDownload = (e) => {
    e.stopPropagation(); // 이벤트 전파 방지
    if (status) {
      alert("다운로드가 현재 준비 중입니다."); // 준비 중 메시지
      return;
    }

    const link = document.createElement("a");
    link.href = image; // 이미지 URL
    link.download = name; // 다운로드 파일 이름
    link.click();
  };

  return (
    <MKBox
      position="relative"
      sx={{
        cursor: "pointer",
        height: "auto",
      }}
      onClick={() => !status && onCardClick()} // 상태에 따라 클릭 이벤트 분기
    >
      {/* 이미지 박스 */}
      <MKBox
        bgColor={status ? "grey.300" : "white"} // 상태에 따라 배경색 변경
        borderRadius="xl"
        shadow="lg"
        sx={{
          overflow: "hidden",
          height: { xs: "180px", sm: "220px", md: "300px" }, // 반응형 높이
          width: { xs: "120px", sm: "160px", md: "200px" }, // 카드 높이 조정
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            transform: status
              ? "none"
              : "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)", // 상태에 따라 hover 동작 비활성화
          },
        }}
      >
        {/* 이미지 */}
        <MKBox
          component="img"
          src={status ? "" : image} // 준비 중일 경우 이미지 숨김
          alt={name}
          width="100%"
          height="100%"
          sx={{
            objectFit: "contain", // 이미지 비율 유지 및 짤림 방지
            display: status ? "none" : "block",
          }}
        />
      </MKBox>

      {/* 이름과 다운로드 아이콘 */}
      <MKBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={1}
        ml={1}
        mr={1}
        lineHeight={1}
        sx={{
          width: { xs: "120px", sm: "160px", md: "200px" }, // 카드 높이 조정
        }}
      >
        {name && (
          <MKTypography
            variant="h6"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "0.70rem", sm: "0.85rem", md: "1.25rem" }, // 반응형 텍스트 크기
            }}
          >
            {name}
          </MKTypography>
        )}
        <IconButton
          onClick={handleDownload} // 다운로드 이벤트
          sx={{
            color: "secondary.main",
            fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" }, // 반응형 아이콘 크기
          }}
        >
          <DownloadIcon />
        </IconButton>
      </MKBox>

      {/* 설명 표시 */}
      {discription && (
        <MKBox mt={1} ml={1} lineHeight={1}>
          <MKTypography
            variant="body2"
            fontWeight="regular"
            color="secondary"
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" }, // 반응형 설명 크기
            }}
          >
            {discription}
          </MKTypography>
        </MKBox>
      )}
    </MKBox>
  );
}

// 기본 props 설정
LicenseCard.defaultProps = {
  name: "",
  discription: "",
  status: false, // 기본적으로 등록 완료 상태
  onCardClick: () => {}, // 기본적으로 빈 함수
};

// PropTypes 설정
LicenseCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string,
  discription: PropTypes.string,
  status: PropTypes.bool, // 상태 추가
  onCardClick: PropTypes.func, // 카드 클릭 이벤트
};

export default LicenseCard;
